module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label title-text",
    attrs: {
      "for": "vrbo-configuration-language"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.lang")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeLang),
      expression: "activeLang"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "vrbo-configuration-language"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeLang()
      }]
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('option', {
      key: language.code,
      domProps: {
        "value": language.code
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t(
      ("account.settings.message_templates_section." + (language.name))
    )) + "\n              ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    attrs: {
      "id": "property-name"
    }
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.property_name_title")) + "\n            ")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control my-10",
    attrs: {
      "cols": "100",
      "rows": "2",
      "name": "propertyName"
    },
    domProps: {
      "value": _vm.property_name
    },
    on: {
      "input": function($event) {
        _vm.changeUserWebContent($event,
          'property_name')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    attrs: {
      "id": "headline"
    }
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.headline_title")) + "\n            ")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control my-10",
    attrs: {
      "cols": "100",
      "rows": "2",
      "name": "headline"
    },
    domProps: {
      "value": _vm.headline
    },
    on: {
      "input": function($event) {
        _vm.changeUserWebContent($event,
          'headline')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    attrs: {
      "id": "description"
    }
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.description_title")) + "\n            ")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control my-10",
    attrs: {
      "cols": "100",
      "rows": "6",
      "name": "description"
    },
    domProps: {
      "value": _vm.description
    },
    on: {
      "input": function($event) {
        _vm.changeUserWebContent($event,
          'description')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    attrs: {
      "id": "accomodations-summary"
    }
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.accomodations_summary_title")) + "\n            ")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control my-10",
    attrs: {
      "cols": "100",
      "rows": "6",
      "name": "accomodationsSummary"
    },
    domProps: {
      "value": _vm.accomodations_summary
    },
    on: {
      "input": function($event) {
        _vm.changeUserWebContent($event,
          'accomodations_summary')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.website.gps_coordinators")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "map-latitude"
    }
  }, [_vm._v("\n                      Latitude\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.map.latitude),
      expression: "map.latitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "map-latitude"
    },
    domProps: {
      "value": (_vm.map.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.map, "latitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "map-longitude"
    }
  }, [_vm._v("\n                      Longitude\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.map.longitude),
      expression: "map.longitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "map-longitude"
    },
    domProps: {
      "value": (_vm.map.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.map, "longitude", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "display"
    },
    domProps: {
      "checked": _vm.map.showExactLocation
    },
    on: {
      "change": _vm.updateShowExactLocation
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "display"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.show_exact_location")))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space",
    attrs: {
      "id": "image"
    }
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.photos_title")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bg-white white-section"
  }, [_c('ImageUploader', {
    attrs: {
      "addImage": _vm.addImage,
      "handleLabelChange": _vm.handleLabelChange,
      "type": "image",
      "value": _vm.image.label,
      "selectImage": _vm.selectImage,
      "fileSelected": _vm.isImageSelected,
      "lang": _vm.account.lang
    }
  }), _vm._v(" "), _c('ImagesBox', {
    attrs: {
      "type": "image",
      "images": _vm.images,
      "imageDeleted": _vm.imageDeleted
    },
    on: {
      "deleteUploadedImage": _vm.deleteUploadedImage,
      "updateImagesOrder": _vm.updateImagesOrder
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bathrooms_title")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bedroom-features"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bathrooms_info")))]), _vm._v(" "), _vm._l((_vm.rental.bathroom_count), function(bathroom, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "bathroom-type"
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bathroom_type")))]), _vm._v(" "), (_vm.vrboBathroomSelectedFeatures[index] && _vm.vrboBathroomSelectedFeatures[index].type) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vrboBathroomSelectedFeatures[index].type),
        expression: "vrboBathroomSelectedFeatures[index].type"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "bathroom-type",
        "id": "bathroom-type"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.vrboBathroomSelectedFeatures[index], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.vrboBathroomTypes), function(bathroomType) {
      return _c('option', {
        domProps: {
          "value": bathroomType
        }
      }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo." + bathroomType)))])
    })) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "bathroom-name"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.bathroom_name_label")) + "\n                    ")]), _vm._v(" "), (_vm.vrboBathroomSelectedFeatures[index] && _vm.vrboBathroomSelectedFeatures[index].name) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vrboBathroomSelectedFeatures[index].name.fr),
        expression: "vrboBathroomSelectedFeatures[index].name.fr"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "bathroom-name"
      },
      domProps: {
        "value": (_vm.vrboBathroomSelectedFeatures[index].name.fr)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.vrboBathroomSelectedFeatures[index].name, "fr", $event.target.value)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "bathroom-description"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.bathroom_description")) + "\n                    ")]), _vm._v(" "), (_vm.vrboBathroomSelectedFeatures[index] && _vm.vrboBathroomSelectedFeatures[index].description) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vrboBathroomSelectedFeatures[index].description.fr),
        expression: "vrboBathroomSelectedFeatures[index].description.fr"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "bathroom-description"
      },
      domProps: {
        "value": (_vm.vrboBathroomSelectedFeatures[index].description.fr)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.vrboBathroomSelectedFeatures[index].description, "fr", $event.target.value)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "bathroom-features"
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bathroom_features")))]), _vm._v(" "), (_vm.vrboAmenitiesFeatures && _vm.vrboAmenitiesFeatures.bathroom && _vm.vrboAmenitiesFeatures.bathroom.amenities && _vm.vrboBathroomSelectedFeatures[index] && _vm.vrboBathroomSelectedFeatures[index].amenities) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vrboBathroomSelectedFeatures[index].amenities),
        expression: "vrboBathroomSelectedFeatures[index].amenities"
      }],
      staticClass: "form-control",
      attrs: {
        "multiple": "",
        "name": "bathroom-features",
        "id": "bathroom-features"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.vrboBathroomSelectedFeatures[index], "amenities", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.vrboAmenitiesFeatures.bathroom.amenities), function(vrboAmenity) {
      return _c('option', {
        domProps: {
          "value": vrboAmenity.id
        }
      }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
    })) : _vm._e()])])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedrooms_title")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bedroom-features"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedrooms_info")))]), _vm._v(" "), _vm._l((_vm.rental.bedroom_count), function(bedroom, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "bedroom-type"
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedroom_type")))]), _vm._v(" "), (_vm.vrboBedroomSelectedFeatures[index] && _vm.vrboBedroomSelectedFeatures[index].type) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vrboBedroomSelectedFeatures[index].type),
        expression: "vrboBedroomSelectedFeatures[index].type"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "bedroom-type",
        "id": "bedroom-type"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.vrboBedroomSelectedFeatures[index], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.vrboBedroomTypes), function(bedroomType) {
      return _c('option', {
        domProps: {
          "value": bedroomType
        }
      }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo." + bedroomType)))])
    })) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "bedroom-name"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedroom_name_label")) + "\n                    ")]), _vm._v(" "), (_vm.vrboBedroomSelectedFeatures[index] && _vm.vrboBedroomSelectedFeatures[index].name) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vrboBedroomSelectedFeatures[index].name.fr),
        expression: "vrboBedroomSelectedFeatures[index].name.fr"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "bedroom-name"
      },
      domProps: {
        "value": (_vm.vrboBedroomSelectedFeatures[index].name.fr)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.vrboBedroomSelectedFeatures[index].name, "fr", $event.target.value)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "bedroom-description"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedroom_description")) + "\n                    ")]), _vm._v(" "), (_vm.vrboBedroomSelectedFeatures[index] && _vm.vrboBedroomSelectedFeatures[index].description) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vrboBedroomSelectedFeatures[index].description.fr),
        expression: "vrboBedroomSelectedFeatures[index].description.fr"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "bedroom-description"
      },
      domProps: {
        "value": (_vm.vrboBedroomSelectedFeatures[index].description.fr)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.vrboBedroomSelectedFeatures[index].description, "fr", $event.target.value)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "bedroom-features"
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedroom_features")))]), _vm._v(" "), (_vm.vrboAmenitiesFeatures && _vm.vrboAmenitiesFeatures.bedroom && _vm.vrboAmenitiesFeatures.bedroom.amenities && _vm.vrboBedroomSelectedFeatures[index] && _vm.vrboBedroomSelectedFeatures[index].amenities) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vrboBedroomSelectedFeatures[index].amenities),
        expression: "vrboBedroomSelectedFeatures[index].amenities"
      }],
      staticClass: "form-control",
      attrs: {
        "multiple": "",
        "name": "bedroom-features",
        "id": "bedroom-features"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.vrboBedroomSelectedFeatures[index], "amenities", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.vrboAmenitiesFeatures.bedroom.amenities), function(vrboAmenity) {
      return _c('option', {
        domProps: {
          "value": vrboAmenity.id
        }
      }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
    })) : _vm._e()])])])
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bedroom-features"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.other_sleeping_area")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bedroom-features"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedroom_type")))]), _vm._v(" "), (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1] && _vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].type) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].type),
      expression: "vrboBedroomSelectedFeatures[vrboBedroomSelectedFeatures.length-1].type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "name": "bedroom-type",
      "id": "bedroom-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboBedroomTypes), function(bedroomType) {
    return _c('option', {
      domProps: {
        "value": bedroomType
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo." + bedroomType)))])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bedroom-name"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedroom_name_label")) + "\n                    ")]), _vm._v(" "), (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1] && _vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].name) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].name.fr),
      expression: "vrboBedroomSelectedFeatures[vrboBedroomSelectedFeatures.length-1].name.fr"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "bedroom-name"
    },
    domProps: {
      "value": (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].name.fr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].name, "fr", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bedroom-description"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedroom_description")) + "\n                    ")]), _vm._v(" "), (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1] && _vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].description) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].description.fr),
      expression: "vrboBedroomSelectedFeatures[vrboBedroomSelectedFeatures.length-1].description.fr"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "bedroom-description"
    },
    domProps: {
      "value": (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].description.fr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].description, "fr", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bedroom-features"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.bedroom_features")))]), _vm._v(" "), (_vm.vrboAmenitiesFeatures && _vm.vrboAmenitiesFeatures.bedroom && _vm.vrboAmenitiesFeatures.bedroom.amenities && _vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1] && _vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].amenities) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1].amenities),
      expression: "vrboBedroomSelectedFeatures[vrboBedroomSelectedFeatures.length-1].amenities"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "bedroom-features",
      "id": "bedroom-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboBedroomSelectedFeatures[_vm.vrboBedroomSelectedFeatures.length - 1], "amenities", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.bedroom.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
  })) : _vm._e()])])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.amenities_title")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.car) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "car-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.car.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.car),
      expression: "vrboAmenitiesSelectedFeatures.car"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "car-features",
      "id": "car-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "car", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.car.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.general) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "general-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.general.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.general),
      expression: "vrboAmenitiesSelectedFeatures.general"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "general-features",
      "id": "general-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "general", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.general.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.locations) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "locations-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.locations.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.locations),
      expression: "vrboAmenitiesSelectedFeatures.locations"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "locations-features",
      "id": "locations-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "locations", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.locations.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.local) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "local-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.local.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.local),
      expression: "vrboAmenitiesSelectedFeatures.local"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "local-features",
      "id": "local-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "local", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.local.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.sports) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "sports-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.sports.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.sports),
      expression: "vrboAmenitiesSelectedFeatures.sports"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "sports-features",
      "id": "sports-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "sports", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.sports.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.attractions) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attractions-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.attractions.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.attractions),
      expression: "vrboAmenitiesSelectedFeatures.attractions"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "attractions-features",
      "id": "attractions-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "attractions", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.attractions.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.leisure) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "leisure-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.leisure.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.leisure),
      expression: "vrboAmenitiesSelectedFeatures.leisure"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "leisure-features",
      "id": "leisure-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "leisure", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.leisure.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.safety) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "safety-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.safety.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.safety),
      expression: "vrboAmenitiesSelectedFeatures.safety"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "safety-features",
      "id": "safety-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "safety", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.safety.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.property_title")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "property-type"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.property_type")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboPropertySelectedType),
      expression: "vrboPropertySelectedType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "property-type",
      "id": "property-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vrboPropertySelectedType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.vrboPropertyTypes), function(propertyType) {
    return _c('option', {
      domProps: {
        "value": propertyType
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo." + propertyType)))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "registration-number"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.registration_number")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationNumber),
      expression: "registrationNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "registration-number"
    },
    domProps: {
      "value": (_vm.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registrationNumber = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "unit_monetary_information"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.unit_monetary_information")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboSelectedCurrency),
      expression: "vrboSelectedCurrency"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "unit_monetary_information",
      "id": "unit_monetary_information"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vrboSelectedCurrency = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.vrboCurrencies), function(vrboCurrency) {
    return _c('option', {
      domProps: {
        "value": vrboCurrency
      }
    }, [_vm._v(_vm._s(vrboCurrency))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "unit_name"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.unit_name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unitName),
      expression: "unitName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "unit_name"
    },
    domProps: {
      "value": (_vm.unitName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.unitName = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.amenities_title")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.kitchen) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "kitchen-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.kitchen.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.kitchen),
      expression: "vrboAmenitiesSelectedFeatures.kitchen"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "kitchen-features",
      "id": "kitchen-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "kitchen", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.kitchen.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.amenities) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "amenities-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.amenities.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.amenities),
      expression: "vrboAmenitiesSelectedFeatures.amenities"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "amenities-features",
      "id": "amenities-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "amenities", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.amenities.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.entertainment) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "entertainment-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.entertainment.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.entertainment),
      expression: "vrboAmenitiesSelectedFeatures.entertainment"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "entertainment-features",
      "id": "entertainment-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "entertainment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.entertainment.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.pool) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "pool-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.pool.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.pool),
      expression: "vrboAmenitiesSelectedFeatures.pool"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "pool-features",
      "id": "pool-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "pool", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.pool.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.accomodations) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "accomodations-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.accomodations.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.accomodations),
      expression: "vrboAmenitiesSelectedFeatures.accomodations"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "accomodations-features",
      "id": "accomodations-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "accomodations", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.accomodations.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.themes) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "themes-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.themes.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.themes),
      expression: "vrboAmenitiesSelectedFeatures.themes"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "themes-features",
      "id": "themes-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "themes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.themes.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v("\n                        " + _vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.vrboAmenitiesFeatures.suitability) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "suitability-features"
    }
  }, [_vm._v(_vm._s(_vm.vrboAmenitiesFeatures.suitability.fr_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboAmenitiesSelectedFeatures.suitability),
      expression: "vrboAmenitiesSelectedFeatures.suitability"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "name": "suitability-features",
      "id": "suitability-features"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vrboAmenitiesSelectedFeatures, "suitability", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vrboAmenitiesFeatures.suitability.amenities), function(vrboAmenity) {
    return _c('option', {
      domProps: {
        "value": vrboAmenity.id
      }
    }, [_vm._v(_vm._s(vrboAmenity.fr_name))])
  }))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.policy")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section p-30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "vrbo-default-booking-policy"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.booking_policy")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboBookingSelectedPolicy),
      expression: "vrboBookingSelectedPolicy"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vrbo-default-booking-policy",
      "id": "vrbo-default-booking-policy",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vrboBookingSelectedPolicy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.vrboBookingPolicies), function(vrboBookingPolicy) {
    return _c('option', {
      domProps: {
        "value": vrboBookingPolicy
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo." + vrboBookingPolicy)))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "vrbo-default-cancellation-policy"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.cancellation_policy")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboCancellationSelectedPolicy),
      expression: "vrboCancellationSelectedPolicy"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vrbo-default-cancellation-policy",
      "id": "vrbo-default-cancellation-policy"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vrboCancellationSelectedPolicy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.vrboCancellationPolicies), function(vrboCancellationPolicy) {
    return _c('option', {
      domProps: {
        "value": vrboCancellationPolicy
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo." + vrboCancellationPolicy)))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "vrbo-default-payment-policy"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.payment_policy")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboPaymentSelectedPolicy),
      expression: "vrboPaymentSelectedPolicy"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vrbo-default-payment-policy",
      "id": "vrbo-default-payment-policy"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vrboPaymentSelectedPolicy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.vrboPaymentPolicies), function(vrboPaymentPolicy) {
    return _c('option', {
      domProps: {
        "value": vrboPaymentPolicy
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo." + vrboPaymentPolicy)))])
  }))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.checks_title")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section p-30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checkin"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.checkin_title")) + "\n                    ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboDefaultCheckin),
      expression: "vrboDefaultCheckin"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "checkin"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vrboDefaultCheckin = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.vrboCheckTimes), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checkout"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.checkout_title")) + "\n                    ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vrboDefaultCheckout),
      expression: "vrboDefaultCheckout"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "checkout"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vrboDefaultCheckout = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.vrboCheckTimes), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  }))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.rules_title")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section p-30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "merchantName"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.merchant_name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.merchantName),
      expression: "merchantName"
    }],
    attrs: {
      "type": "text",
      "id": "merchantName"
    },
    domProps: {
      "value": (_vm.merchantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.merchantName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "maxAdults"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.maximum_occupancy_adults")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maximumOccupancyAdults),
      expression: "maximumOccupancyAdults"
    }],
    attrs: {
      "type": "number",
      "id": "maxAdults",
      "min": "1"
    },
    domProps: {
      "value": (_vm.maximumOccupancyAdults)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maximumOccupancyAdults = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "maxGuests"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.maximum_occupancy_guests")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maximumOccupancyGuests),
      expression: "maximumOccupancyGuests"
    }],
    attrs: {
      "type": "number",
      "id": "maxGuests",
      "min": "0"
    },
    domProps: {
      "value": (_vm.maximumOccupancyGuests)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maximumOccupancyGuests = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "minAge"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.minimum_age_rule")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minimumAgeRule),
      expression: "minimumAgeRule"
    }],
    attrs: {
      "type": "number",
      "id": "minAge",
      "min": "0"
    },
    domProps: {
      "value": (_vm.minimumAgeRule)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minimumAgeRule = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.agreements_title")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section p-30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.agreements_infos")))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "agreementsPdfFile"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.rental_agreement_file")))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "agreementsPdfFile",
      "name": "agreementsPdfFile",
      "accept": ".pdf"
    },
    on: {
      "change": _vm.uploadAgreementsPdfFile
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "agreementsPdfFileUrl"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.agreements_file_url")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreementsPdfFileUrl),
      expression: "agreementsPdfFileUrl"
    }],
    attrs: {
      "type": "text",
      "id": "agreementsPdfFile",
      "size": "100",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.agreementsPdfFileUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.agreementsPdfFileUrl = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('label', {
    staticClass: "control-label title-text"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.custom_house_rules")))]), _vm._v(" "), _c('div', {
    staticClass: "map-section bg-white white-section p-30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "customHouseRule1"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.custom_house_rules_1")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customHouseRule1),
      expression: "customHouseRule1"
    }],
    staticClass: "form-control my-10",
    attrs: {
      "id": "customHouseRule1",
      "name": "customHouseRule1",
      "cols": "70",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.customHouseRule1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customHouseRule1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "customHouseRule2"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.custom_house_rules_2")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customHouseRule2),
      expression: "customHouseRule2"
    }],
    staticClass: "form-control my-10",
    attrs: {
      "id": "customHouseRule1",
      "name": "customHouseRule2",
      "cols": "70",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.customHouseRule2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customHouseRule2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "customHouseRule3"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.custom_house_rules_3")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customHouseRule3),
      expression: "customHouseRule3"
    }],
    staticClass: "form-control my-10",
    attrs: {
      "id": "customHouseRule3",
      "name": "customHouseRule3",
      "cols": "70",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.customHouseRule3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customHouseRule3 = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "the-space"
  }, [_c('div', {
    staticClass: "map-section bg-white white-section p-30"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "enableChildren"
    },
    domProps: {
      "checked": _vm.vrboDefaultChildrenEnabled
    },
    on: {
      "change": _vm.enableChildren
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableChildren"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.children_enabled")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "enableEvents"
    },
    domProps: {
      "checked": _vm.vrboDefaultEventsEnabled
    },
    on: {
      "change": _vm.enableEvents
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableEvents"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.events_enabled")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "enablePets"
    },
    domProps: {
      "checked": _vm.vrboDefaultPetsEnabled
    },
    on: {
      "change": _vm.enablePets
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enablePets"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.pets_enabled")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "enableSmoking"
    },
    domProps: {
      "checked": _vm.vrboDefaultSmokingDisabled
    },
    on: {
      "change": _vm.enableSmoking
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableSmoking"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.smoking_enabled")))])])])])])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d1a7938"}!./src/app/pages/rentals/detail/VrboConfigurationTab/VrboConfigurationTab.html
// module id = 1367
// module chunks = 0